//updated: 18.11.2025

export default {
    //Panel SOS
    panel_sos_title: "求助 (SOS)",
    panel_sos_position: "您的位置:",
    panel_sos_position_not_found: "无法确定位置",
    panel_sos_position_not_available: "请启用位置分享",
    panel_sos_phonesupport: "电话咨询",
    panel_sos_hospitals: "您附近的医院",


    language: "简体中文",
    language_title: "你好",
    language_message: "您好",
    language_button_next: "确认语言选择",

    //Screen titles and leads
    intro_message: "心理健康， <br />数字化传递。",
    welcome_title: "欢迎来到 Swiss<span class='text-light'>DTx</span>",
    welcome_message: "提供混合护理。几乎无处不在。",
    login_title: "登录",
    login_message: "请使用您的电子邮件地址和密码登录。",
    pincode_title: "输入密码 (Pincode)",
    pincode_message: "为了安全起见，请输入您的密码 (Pincode)。",
    dashboard_title: "您好,",
    dashboard_message: "很高兴见到您！",
    dashboard_exercise_title: "您的练习",
    dashboard_journal_title: "日记",
    dashboard_more_title: "不知道下一步该怎么做？",

    //... [Rest of the cn.js content is here]
    invitation_title: "输入邀请码",
    invitation_message: "您已从治疗师那里收到个人邀请码。请在此处输入：",
    create_account_title: "创建用户账户",
    create_account_agb: "...", // Simplified to save space
    create_account_confirm_agb: "我已阅读并同意<a href=\"https://www.swissdtx.com/imprint\" class=\"external\" target=\"_blank\">使用条款和一般条款 (AGB)</a>。",
    create_account_set_pw_title: "设置密码",
    create_account_set_pw_text: "...", // Simplified to save space
    create_account_set_pw_password: "密码",
    create_account_set_pw_password_repeat: "重复密码",
    create_account_set_pincode_title: "设置密码 (Pincode)",
    create_account_set_pincode_text: "为了确保除了您之外没有人可以看到您的信息，您还必须设置一个4位数的密码 (Pincode)。",
    create_account_set_profile_picture_title: "选择个人资料图片",
    create_account_set_profile_picture_text: "让您的帐户更加个性化，并上传自己的个人资料图片。",
    create_account_set_theme_title: "个性化应用程序",
    create_account_set_theme_text: "您可以在此处选择应用程序的外观。",
    create_account_finish_title: "您的个人资料已创建, ",
    create_account_finish_button: "立即开始",

    therapy_progress: "进度",
    therapy_unlock: "开始会话",
    therapy_cards_writehere: "在此处写入...",
    therapy_cards_reminder_monday: "一",
    therapy_cards_reminder_tuesday: "二",
    therapy_cards_reminder_wednesday: "三",
    therapy_cards_reminder_thursday: "四",
    therapy_cards_reminder_friday: "五",
    therapy_cards_reminder_saturday: "六",
    therapy_cards_reminder_sunday: "日",
    therapy_cards_reminder_morning: "上午",
    therapy_cards_reminder_noon: "中午",
    therapy_cards_reminder_afternoon: "下午",
    therapy_cards_reminder_evening: "晚上",

    //Panel Notes
    panel_notes_title: "您的笔记",
    panel_notes_note: "笔记",
    panel_notes_dialog_title: "新笔记",
    panel_notes_dialog_save: "保存笔记",

    //Panel Messages
    panel_messages_title: "消息",

    //Panel Settings
    panel_settings_title: "设置",
    panel_settings_personalization: "个性化",
    panel_settings_account: "您的账户",
    panel_settings_app_settings: "应用设置",
    panel_settings_notifications: "通知",
    panel_settings_reminders: "Reminders",
    panel_settings_account_security: "账户和安全",
    panel_settings_password_pincode: "密码 & PIN 码",
    panel_settings_privacy: "数据 & 安全",
    panel_settings_about: "关于此应用",
    panel_settings_terms: "使用条款",

    panel_settings_account_personal_data: "个人资料",
    panel_settings_account_salutation: "称谓",
    panel_settings_account_salutation_placeholder: "称谓",
    panel_settings_account_first_name: "名字",
    panel_settings_account_first_name_placeholder: "您的名字",
    panel_settings_account_last_name: "姓氏",
    panel_settings_account_last_name_placeholder: "您的姓氏",
    panel_settings_account_address: "街道 / 号码",
    panel_settings_account_address_placeholder: "您的地址",
    panel_settings_account_zip: "邮政编码",
    panel_settings_account_zip_placeholder: "您的邮政编码",
    panel_settings_account_city: "城市",
    panel_settings_account_city_placeholder: "您的居住地",
    panel_settings_account_login_contact: "登录和联系方式",
    panel_settings_account_email: "电子邮件",
    panel_settings_account_email_placeholder: "您的电子邮件地址",
    panel_settings_account_phone: "电话",
    panel_settings_account_phone_placeholder: "手机号码",

    panel_settings_app_settings_title: "应用设置",
    panel_settings_app_settings_text: "通过选择合适的外观，为您的应用增添个人风格:",
    panel_settings_app_settings_skin: "应用外观 (Skin)",
    panel_settings_app_settings_skin_placeholder: "选择您的外观 (Skin)",

    panel_settings_notifications_title: "通知",
    panel_settings_notifications_text: "选择您希望如何接收重要通知。",
    panel_settings_notifications_email: "电子邮件",
    panel_settings_notifications_push: "推送通知 (Push)",

    panel_settings_password_title: "密码 & Pin",
    panel_settings_password_text: "您可以在此处更改密码和 PIN 码。应用登录的用户名始终是您的电子邮件地址。<br /><br />密码和 PIN 码会自动保存，之后将不再可见。",
    panel_settings_password_password: "密码",
    panel_settings_password_password_placeholder: "请输入您的新密码",
    panel_settings_password_pincode_pincode: "PIN 码",
    panel_settings_password_pincode_placeholder: "您的新 PIN 码",

    panel_settings_privacy_title: "数据 & 安全",
    panel_settings_privacy_text: "Last updated on December 31st, 2023<br /><br />As part of online therapy, personal data and the medical data required for treatment are collected, recorded, stored, processed, queried, used or transmitted. <br /><br />All data exchanged between the licensee and their patients are encrypted and not openly visible to SwissDTx. SwissDTx DOES NOT anaylse, review or distribute data to other parties.<br />However, in order to provide the online therapy, we collect and process both general personal data and data relating to your health. Health data is all data relating to the physical or mental health of a patient. This includes, for example, data that is clearly related to health, as well as data that allows conclusions to be drawn about the state of health or where conclusions about the state of health have already been drawn, regardless of whether they are correct or incorrect. These processed data can represent health data both individually and in an overall view.<br /><br />1. Purposes for which personal data is processed<br />SwissDTx may only process patient data if a legal basis requires or permits this or if the patient gives their consent:<br />First of all, data is required to register as a patient and to set up a user account. In this context, a comparison is carried out with existing user data from the SwissDTx app (SwissDTx GmbH) in order to take into account the goals of data security and economy and to avoid duplication of accounts. This is done to protect the interests of the users concerned on the basis of the legitimate interest in accordance with Article 6 Paragraph 1 Sentence 1 Letter f of the GDPR and as part of the agreement on shared responsibility in accordance with Article 26 of the GDPR.<br />Collection and storage of the contact details of emergency contacts in order to fulfill our therapeutic due diligence obligations (Art. 6 Para. 1 S. 1 lit. c in conjunction with Art. 9 Para. 2 lit. h, Para. 3 GDPR).<br />For treatment (online psychotherapy), it is particularly necessary to process patient data for preventive, diagnostic, therapeutic, curative and follow-up reasons<br />In addition, the data is processed with a view to interdisciplinary conferences for the analysis and discussion of diagnostics and therapy, for preliminary, additional and further care with regard to diagnostics, therapy, findings and disease/vital status. All this processing is carried out to ensure the best possible treatment<br />In addition to this patient-related processing, administrative and supportive processing is also required. This essentially requires the processing of the data for billing the treatment, for reasons of controlling or auditing, for the assertion, exercise and defense of legal claims, etc.<br />Data processing also takes place for the purposes of training, further education and training for doctors and members of other healthcare professions as well as for reasons of support and maintenance of IT systems and applications as well as to resolve technical errors or questions from individual patients<br />The data can also be used for quality and analysis purposes to improve therapy processes and content, as well as to improve the user experience during online psychotherapy<br />Patient data may be required as part of measuring the effect size of online therapy for internal quality assurance purposes and to measure the stability of the treatment offered via standardized questionnaires<br /><br />2. Type of the personal data processed<br />The following personal data is collected by the licencee as part of software usage:<br />- First name(s)<br />- Last name(s)<br />" +
        "- E-mail address<br />" +
        "- Birth date<br />" +
        "- Phone number<br />" +
        "- Gender<br />" +
        "- IP address<br />" +
        "- Device ID<br />" +
        "- Profile photo<br />" +
        "- Medical history<br />" +
        "- Profile-Information from relatives <br />" +
        "- Contact details of third parties as part of a specified emergency contact (email address, first name, last name)<br />" +
        "<br />" +
        "As well as details provided during the usage of the software:<br />" +
        "- Written text and survey answers provided during the therapeutic interventions<br />" +
        "- Notes<br />" +
        "- Data collected from therapeutic users (psychotherapists, psychiatrists) only<br />" +
        "<br />" +
        "2. ACCESS AUTHORIZATION TO DATA<br />" +
        "Only the people involved in the treatment (i.e. therapists, psychiatrists, doctors and the patients) have access to the patient data. These access permissions are processed, administered and managed by the licensee only and strictly under their responsibility. These specialist personnel are either subject to so-called professional secrecy or a duty of confidentiality.<br />" +
        "If necessary for administrative or technical purposes, an administrative employee (e.g. patient management, technical support) can also access patient data (anonymized and/or openly visible). The confidential handling of your data is also guaranteed here through appropriate confidentiality obligations.<br />" +
        "<br />" +
        "3.POSSIBLE RECIPIENTS OF DATA<br />" +
        "All data is collected within the scope of the intended purpose in compliance with the respective data protection regulations or any existing declarations of consent and, only if necessary, transmitted to third parties. In particular, such third parties come into consideration:<br />" +
        "Medical personnel, healthcare professionals and further, subsequent or co-treating doctors, therapists and/or assisting personnel as well as scientists and national health departments and national statistical services.  Health care or treatment facilities, rehabilitation facilities, care facilities. All the above mentioned are responsible to comply with legal standards in regards to data protection and data security. This means that the processors are bound to our instructions. <br />" +
        "<br />" +
        "3. STORAGE PERIOD OF PROVIDED DATA <br />" +
        "SwissDTx is obliged to keep documentation of your treatment. We must keep this patient file for at least 10 years and can, in individual cases, preserve evidence for up to 30 years.<br />" +
        "<br />" +
        "4. DATA SUBJECT RIGHTS <br />" +
        "All users under this data protection declaration are entitled to so-called data subject rights, i.e. rights that the persons affected can exercise in individual cases. These rights can be asserted against those responsible. The rights arise from the GDPR:<br />" +
        "Right to information, Art. 15 GDPR<br />" +
        "Right to information about the personal data we process.<br />" +
        "Right to restriction of processing, Art. 18 GDPR<br />" +
        "Restricting the processing of personal data if certain reasons apply. This means that the data will not be deleted, but will be marked to restrict its further processing or use.<br />" +
        "Right to object to unreasonable data processing, Art. 21 GDPR<br />" +
        "If we process data on the basis of a legitimate interest, you can object to this data processing at any time; this would also apply to profiling based on these provisions. We will then no longer process data unless we can demonstrate compelling legitimate reasons for the processing that outweigh the interests, rights and freedoms of our users or the processing serves to assert, exercise or defend legal claims. The processing of user data for the purpose of direct advertising can be objected to at any time without giving reasons.<br />" +
        "Right to deletion, Art. 17 GDPR<br />" +
        "The deletion of personal data under the conditions specified in the article; This is particularly the case if they are no longer necessary for the purpose for which they were originally collected or processed.<br />" +
        "Right to rectification, Art. 16 GDPR<br />" +
        "Immediate correction of incorrect personal data concerning the user.<br />" +
        "Right to portability, Art. 20 GDPR<br />" +
        "Users of the services generally have the right to receive the personal data concerning them that they have provided in a structured, common and machine-readable format and to transmit this data to another person responsible without hindrance from us; The user also has the right to request that we transmit the personal data directly to another person responsible, if this is technically feasible; provided that the processing was based on consent or is based on a contract with us and the processing is carried out using automated procedures.",

    panel_settings_terms_title: "使用条款",
    panel_settings_terms_text: "Last updated on December 31st, 2023<br />" +
        "<br />" +
        "The SwissDTx software application (herein referred to as \"Software Product\" or \"Software\") is licensed to You (End-User) by SwissDTx GmbH., located at Recheraulaz 10, 3280 Meyriez, Switzerland (”Owner”), for user only under the terms of this License Agreement. By installing the Software, you are agreeing to be bound by the terms of this license agreement.<br />" +
        "<br />" +
        "1. LICENSE. The Software is licensed to the licensee that created your user account. The Owner grants you a non-exclusive, non-transferable, non-sublicensable, limited right and license to use one copy of the Software for your personal non-commercial use on a single device. The rights granted herein are subject to your compliance with this EULA. The Software is being licensed to you and you hereby acknowledge that no title or ownership in the Software is being transferred or assigned and this EULA is not to be construed as a sale of any rights in the Software.<br />" +
        "<br />" +
        "2. RESTRICTIONS OF USE. Unless the Owner has authorized you to distribute the Software, you shall not make or distribute copies of the Software, the contents displayed or duplicate the contents displayed. All provided contents, including standardized surveys, assessments, screeners, the interventions themselves as well as all texts, graphics, images and videos, are protected by intellectual property. You shall not decompile, reverse engineer, disassemble, include in other software, or translate the Software, or use the Software for any commercial purposes without a license. You shall not modify, alter, change or otherwise make any modification to the information displayed or create derivative works based upon the Software or the contents displayed. You shall not rent, lease, resell, sub-license, assign, distribute or otherwise transfer the Software or this license to any other persons without a written consent by SwissDTx. <br />" +
        "<br />" +
        "3. COPYRIGHT. You acknowledge that no title to the intellectual property in the Software or the contents displayed  are transferred to you. You further acknowledge that title and full ownership rights to the Software will remain the exclusive property of SwissDTx and their licensees, and you will not acquire any rights whatsoever. You shall not remove or obscure the Owner's copyright, trademark or other proprietary notices from any of the materials contained in this package or downloaded together with the Software.<br />" +
        "<br />" +
        "4. DISCLAIMER OF WARRANTY. The Software is provided \"AS IS\", without warranty of any kind. We disclaim and make no express or implied warranties and specifically disclaim the warranties of merchantability, fitness for a particular purpose and non-infringement of third-party rights. The entire risk as to the quality and performance of the Software is with you. We do not warrant that the functions contained in the Software will meet your requirements or that the operation of the Software will be error-free.<br />" +
        "<br />" +
        "5. LIMITATION OF LIABILITY. In no event will the Owner be liable for special, incidental or consequential damages resulting from possession, access, use or malfunction of the Software, including but not limited to damages to personal health, loss of goodwill, computer or mobile device malfunction and, to the extent permitted by law, damages for personal injuries, property damage, lost profits or punitive damages from any causes of action arising out of or related to this EULA or the Software, whether arising in tort (including negligence), contract, strict liability or otherwise and whether or not the Owner has been advised of the possibility of such damages.<br />" +
        "<br />" +
        "6. LIMITATIONS OF LIABILITY<br />" +
        "Because some states/countries do not allow certain limitations of liability, this limitation of liability shall apply to the fullest extent permitted by law in the applicable jurisdiction. This limitation of liability shall not be applied solely to the extent that any specific provision of this limitation of liability is prohibited by any federal, state, or municipal law, which cannot be pre-empted. This EULA gives you specific legal rights, and you may have other rights that vary from jurisdiction to jurisdiction. In no event shall the Owner's liability for all damages (except as required by applicable law) exceed the actual price paid by you for use of the Software.<br />" +
        "<br />" +
        "7. INDEMNITY. You agree to indemnify, defend and hold the Owner harmless from and against any and all damages, losses, and expenses arising directly or indirectly from: (i) your acts and omissions to act in using the Software pursuant to the terms of the EULA; or (ii) your breach of this EULA.<br />" +
        "<br />" +
        "8. CHANGES. We reserve the right, at our sole discretion, to modify or replace these Terms at any time. Any changes we may make to our privacy policy in the future will be posted on this page. You should check this page from time to time and take note of any changes.<br />" +
        "<br />" +
        "9. MEDICAL DISCLAIMER. The Software is not intended to be a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of your physician or other qualified health providers with any questions you may have regarding a medical condition. Never disregard professional medical advice or delay in seeking it because of something you have seen in this Software. If you think you may have an emergency, go to the next emergency department, or call emergency immediately. Reliance on any information provided by SwissDTx or our employees is solely at your own risk.<br />",

    panel_contacts_title: "您的联系人",
    panel_contacts_family: "家人",
    panel_contacts_friends: "朋友",
    panel_contacts_other: "其他",

    panel_emergency_plan_title: "您遇到紧急情况了吗?",
    panel_emergency_plan_text_1: "危机情况下的行为",
    panel_emergency_plan_text_2: "有时我们需要外界帮助，以防止困难演变成危机。因此，您可以在此处找到在危机情况下可以提供帮助的应急计划的 3 个步骤。请记住：寻求帮助是完全可以的！",
    panel_emergency_plan_step_1: "第 1 阶段",
    panel_emergency_plan_step_1_title: "利用自己的资源",
    panel_emergency_plan_step_1_text: "到目前为止，什么帮助了您？您能否通过听音乐、呼吸新鲜空气或分散注意力来避免危机？",
    panel_emergency_plan_step_2: "第 2 阶段",
    panel_emergency_plan_step_2_title: "在自己的环境中寻求支持",
    panel_emergency_plan_step_2_text: "如果第 1 阶段不够，您可以向谁求助？立即联系可以与您讨论问题的人 (父母、亲戚、朋友)。",
    panel_emergency_plan_step_3: "第 3 阶段",
    panel_emergency_plan_step_3_title: "寻求专业支持",
    panel_emergency_plan_step_3_text: "如果您遇到危机，不知道该怎么办，您总可以在危机中心（例如医院的急诊室）找到支持。您也应该这样做。您可以在 SOS 菜单项下找到地址。",

    panel_therapy_title: "您的项目",
    panel_activity_title: "您的活动",

    panel_documents_title: "您的文件",
    panel_documents_text: "没有可供下载的文件。",

    //Buttons and actions
    button_start: "继续",
    button_next: "继续",
    button_signin: "登录",
    button_createAccount: "创建账户",
    button_login: "登录",
    button_logout: "登出",
    button_trackmood: "记录情绪",
    button_start_therapy_session: "开始会话",
    button_start_exercise: "开始练习",
    button_start_moodtracking: "开始记录",

    //Thesaurus
    thesaurus_close: "关闭说明",

    //Therapy menu
    menu_therapy_notes: "查看笔记",
    menu_therapy_contact: "联系辅导员",
    menu_therapy_messages: "写消息",
    menu_therapy_endsession: "结束会话",

    //Exercise menu
    menu_exercise_notes: "查看笔记",
    menu_exercise_contact: "联系辅导员",
    menu_exercise_messages: "写消息",
    menu_exercise_endexercise: "结束练习",

    //Moodtracking menu
    menu_moodtracking_notes: "查看笔记",
    menu_moodtracking_contact: "联系辅导员",
    menu_moodtracking_messages: "写消息",
    menu_moodtracking_endtracking: "结束记录",

    //Menu-Buttons
    menu_button_notes_title: "笔记",
    menu_button_notes_byline: "查看所有",
    menu_button_mood_title: "活动",
    menu_button_mood_byline: "进度",
    menu_button_therapy_title: "项目",
    menu_button_therapy_byline: "历史记录和预约",
    menu_button_files_title: "文件",
    menu_button_files_byline: "输入",

    menu_button_exercises_title: "练习",
    menu_button_messages_title: "消息",
    menu_button_activities_title: "活动",
    menu_button_chat_title: "聊天",
    menu_button_contacts_title: "联系人",
    menu_button_emergencyplan_title: "应急计划",
    menu_button_sos_title: "SOS",
    menu_button_settings_title: "设置",

    //Form labels
    label_email: "电子邮件",
    label_password: "密码",

    //Errormessages
    error_login_title: "登录失败",
    error_login_message_missing_email_password: "请输入电子邮件地址和密码",
    error_login_message_failed: "您的用户名、密码和 PIN 码组合无效",
    error_invitation_title: "代码无效",
    error_invitation_message_failed: "输入的代码无效。请重试或联系您的治疗师。",

    error_resetcode_title: "Invalid code",
    error_resetcode_expired_message: "The code you entered is no longer valid.",
    error_resetcode_wrong_message: "The code you entered is not correct. Please check your inbox.",
    panel_settings_reminders_title: "提醒",
    panel_settings_reminders_text: "您可以在此暂停或删除提醒",
    panel_sos_position_searching: "正在确定位置 …",
    error_session_expired: "您的会话已过期，请重新登录。",
    error_network_message: "无法连接到服务器，请稍后再试。",
    panel_notes_dialog_edit_title: "编辑笔记",
    panel_notes_dialog_delete: "删除笔记",
    panel_notes_delete_confirm: "确定要删除这条笔记吗？",
    panel_notes_inline_save: "保存",
    panel_notes_inline_cancel: "取消",
    panel_notes_edit_hint: "点击文本进行编辑",
    panel_documents_root: "所有文档",
    panel_documents_folder_empty: "此文件夹为空。",
    panel_documents_unavailable: "此文件尚不可用。",
};
